/**
 * このファイルにはダウンロード履歴の加工・抽出処理を定義する。
 *
 * 一覧（サマリー）はバックエンドで集約済みのため加工不要だが、
 * 明細レコードの表示用フィールド（氏名・会社・役職）を取り出すヘルパーを提供する。
 */

/**
 * サマリー行を一意に識別するキーを生成する。
 * サマリーはid列を持たず、(ownership_user_id, instructed_at)単位で集約されているため、
 * この2値を組み合わせてキーとする。
 *
 * @param {object} summary サマリー行（ownership_user_id, instructed_atを含む）
 * @return {string} キー
 */
export const buildSummaryKey = (summary) => {
  return `${summary.ownership_user_id}_${summary.instructed_at}`;
}

/**
 * 明細レコードから表示用の氏名を取得する。
 * executive_personを優先し、なければrelocation_personnelから取得する。
 *
 * @param {object} row 明細レコード
 * @return {string} 氏名
 */
export const getDetailPersonName = (row) => {
  if (row && row.executive_person && row.executive_person.name) {
    return row.executive_person.name;
  }
  if (row && row.relocation_personnel && row.relocation_personnel.name) {
    return row.relocation_personnel.name;
  }
  return '';
}

/**
 * 明細レコードから表示用の会社名を取得する。
 * corporation_idで紐づくcorporationsの名称を、executive_personを優先して取得する。
 * （氏名と同様、executive_person→relocation_personnelの順でフォールバックする）
 *
 * @param {object} row 明細レコード
 * @return {string} 会社名
 */
export const getDetailCompany = (row) => {
  if (row && row.executive_person && row.executive_person.corporation && row.executive_person.corporation.name) {
    return row.executive_person.corporation.name;
  }
  if (row && row.relocation_personnel && row.relocation_personnel.corporation && row.relocation_personnel.corporation.name) {
    return row.relocation_personnel.corporation.name;
  }
  return '';
}

/**
 * 明細レコードから表示用の役職を取得する。
 *
 * @param {object} row 明細レコード
 * @return {string} 役職
 */
export const getDetailHonorific = (row) => {
  return (row.relocation_personnel && row.relocation_personnel.honorific) ? row.relocation_personnel.honorific : '';
}



// WEBPACK FOOTER //
// ./src/utils/downloadHistoryUtils.js